import React from "react";

import Applet from "../../Applet";
import {withAppContext} from "../../../../util/withAppContext";
import DocumentRevisionTable from "../../../../components/General/DocumentRevisionTable";

class DocumentRevisionTableApplet extends Applet {

    render() {
        return <DocumentRevisionTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Document Revisions"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
                                       appContext={this.props.appContext}
                                       simpleSearch={this.state.SimpleSearch}
        />;
    }

    state = {
        Name: "DocumentRevisionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 50,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 5,
            "lg": 5,
            "lx": 5,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "DocumentID",
                },
                {
                    id: "DisplayRevision",
                },
                {
                    id: "Status",
                },
                {
                    id: "Name",
                },
                {
                    id: "ApprovalRequestID",
                },
                {
                    id: "ReleasedAt",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "DocumentID",
                width: 150,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Document ID",
            },
            {
                id: "DisplayRevision",
                width: 50,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Rev",
            },
            {
                id: "Status",
                width: 125,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "State",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "ApprovalRequestID",
                width: 125,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "AR ID",
            },
            {
                id: "ReleasedAt",
                width: 125,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Released",
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "DocumentID",
                    "DisplayName": "Document ID",
                }]
            }
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "DocumentID",
                                },
                                {
                                    id: "Name",
                                },
                                {
                                    id: "Status",
                                },
                                {
                                    id: "DocumentTypeAcronym",
                                },
                                {
                                    id: "ApprovalRequestID",
                                },
                                {
                                    id: "ReleasedAt",
                                },
                                {
                                    id: "LastModifiedDatetime",
                                },
                                {
                                    id: "SearchableContent",
                                }
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "DocumentID": {
                    id: "DocumentID",
                    enterpriseComponentAttribute: "DocumentID",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Document ID",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Name",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Status": {
                    id: "Status",
                    enterpriseComponentAttribute: "Status",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "State",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                },
                "DocumentTypeAcronym": {
                    id: "DocumentTypeAcronym",
                    enterpriseComponentAttribute: "DocumentTypeAcronym",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Acronym",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "ApprovalRequestID": {
                    id: "ApprovalRequestID",
                    enterpriseComponentAttribute: "ApprovalRequestID",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "AR ID",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "ReleasedAt": {
                    id: "ReleasedAt",
                    enterpriseComponentAttribute: "ReleasedAt",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Created On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
                "LastModifiedDatetime": {
                    id: "LastModifiedDatetime",
                    enterpriseComponentAttribute: "LastModifiedDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Updated On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
                "SearchableContent": {
                    id: "SearchableContent",
                    enterpriseComponentAttribute: "SearchableContent",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Keyword Search",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Search",
                    requiresConfirmation: false,
                },
            }
        }
    };
}

export default withAppContext(DocumentRevisionTableApplet);